module.exports = __webpack_public_path__ + "img/slide-3-image@3x.d129fc58.jpg";